<template>
	<div class="customerC" :style="{'height': clientHeight+'px' }">
		<div class="leftBox">
			<el-button type="primary" plain class="addButtonClass" @click="backClick()">返回</el-button>
			<span class="nameClass">{{nameValue}}</span>
			<div class="tabBox">
				<el-button @click="foldClick()" size="mini" v-if="this.foldVal" style="margin-bottom: 6px;"><i class="iconfont icon-zhedie4"></i></el-button>
				<el-button @click="foldClick()" size="mini" v-if="!this.foldVal" style="margin-bottom: 6px;"><i class="iconfont icon-zhedie3"></i></el-button>
				<!--<list :list="projectList"></list>-->
				<el-tree class="filter-tree" :data="projectList" :props="defaultProps" default-expand-all :filter-node-method="filterNode" ref="tree" :expand-on-click-node="false" node-key="code" @node-click="handleNodeClick" highlight-current :current-node-key="currentNodeKey" id="filterTree">
					<span slot-scope="{ node, data }" style="display: inline-block;width:90%;display: flex;justify-content: space-between;">
      				<span style="display: inline-block;height:25px;line-height: 25px;overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
">
        				<i :class="data.icon"></i>{{ data.name }}
      				</span>
					<!--<el-button type="primary" plain class="addButtonClass2" v-if="data.parent_id==undefined">导入项目下设备</el-button>-->
					</span>
				</el-tree>
			</div>
		</div>
		<div class="contenBox">
			<el-main>
				<Gateway v-if="typeValue==2"></Gateway>
				<Equipment v-if="typeValue==1"></Equipment>
				<Project v-if="!typeValue"></Project>
				<!--<router-view></router-view>-->
			</el-main>
		</div>
		<!--弹窗-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<el-form>
				<el-form-item label="用户名" label-width="20%">
					<el-input type="text" v-model="username" autocomplete="off" @change="usernameChange()"></el-input>
				</el-form-item>
				<el-form-item label="密码" label-width="20%">
					<el-input type="password" v-model="passwordValue" autocomplete="off" @change="passwordChange()"></el-input>
					<el-input type="password" v-model="password" autocomplete="off" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" label-width="20%">
					<el-input type="password" v-model="confirmPasswordValue" autocomplete="off" @change="confirmPasswordChange()"></el-input>
					<el-input type="password" v-model="confirmPassword" autocomplete="off" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="手机号" label-width="20%">
					<el-input type="text" v-model="tel" autocomplete="off" @change="usernameChange()"></el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="save()" class="confrim" type="primary">立即创建</el-button>
				<el-button @click="dialogFormVisible=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import List from "./List";
	import Gateway from "./Gateway";
	import Equipment from "./Equipment";
	import Project from "./Project";
	import headers from '../../../static/js/headers.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		name: "Parent",
		components: {
			List,
			Gateway,
			Equipment,
			Project,
		},
		mounted() {
			if(this.$route.query.id) {
				this.currentId = this.$route.query.id
			}
			//获取某个类距离顶部的距离
			var offset = $(".customerC").offset()
			//某个id的高度（注意：要是id）
			//var box1 =document.getElementById("home_headerB").offsetHeight
			this.clientHeight = document.body.clientHeight - offset['top']
			this.firstPageIndex = this.$route.query.fI
			this.secondPageIndex = this.$route.query.sI

			/*c_id*/
			var c_id = this.$route.query.c_id
			if(c_id) {
				window.sessionStorage.setItem('c_id', c_id)
			}
			this.c_id = window.sessionStorage.getItem('c_id')
			/*nameValue*/
			var nameValue = this.$route.query.name
			if(nameValue) {
				window.sessionStorage.setItem('nameValue', nameValue)
			}
			this.nameValue = window.sessionStorage.getItem('nameValue')

			/*b_id*/
			var b_id = this.$route.query.b_id
			if(b_id) {
				window.sessionStorage.setItem('b_id', b_id)
			}
			this.b_id = window.sessionStorage.getItem('b_id')
			this.getList(); //获取列表
			this.currentNodeKey = window.sessionStorage.getItem('currentNodeKey')
			window.addEventListener('resize', () => {
				var offset = $(".customerC").offset()
				//某个id的高度（注意：要是id）
				//var box1 =document.getElementById("home_headerB").offsetHeight
				this.clientHeight = document.body.clientHeight - offset['top']
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "64%"
				} else {
					this.dialogWidth = "30%"
				}
			})
			this.currentNodeKey = window.sessionStorage.getItem('currentNodeKey')
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
				this.dialogWidth2 = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "64%"
				this.dialogWidth2 = "70%"
			} else {
				this.dialogWidth = "36%"
				this.dialogWidth2 = "50%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				currentId: '',
				clientHeight: '', //滚动高度
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				firstPageIndex: '', //第一个页面的当前页
				secondPageIndex: '', //第二个页面的当前页
				total: 0, //总条数
				tableData: [],
				projectList: [], //
				dialogFormVisible: false,
				title: '', //弹窗标题
				/*表单*/
				username: '', //用户名
				password: '', //密码
				tel: '', //手机号
				confirmPassword: '', //确认密码
				passwordValue: '', //密码
				confirmPasswordValue: '', //确认密码
				dialogWidth: '30%', //dialog的宽度
				editId: null, //编辑的id
				notDo: false, //不执行开关
				listRow: {}, //编辑行数据
				c_id: '', //c_id
				nameValue: '', //下属客户的客户名称
				b_id: '',
				defaultProps: { //列表对应的值
					children: 'children',
					label: 'name'
				},
				currentNodeKey: '',
				typeValue: '',
				foldVal: true,
			}
		},
		methods: {
			foldClick() {
				this.foldVal = !this.foldVal
				if(this.foldVal) {
					for(var i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
						this.$refs.tree.store._getAllNodes()[i].expanded = true;
					}
				} else {
					for(var i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
						this.$refs.tree.store._getAllNodes()[i].expanded = false;
					}
				}
			},
			handleNodeClick(e) {
				this.typeValue = e.type
				window.sessionStorage.setItem('currentNodeKey', e.code)
				if(e.type == 1) { //设备
					this.$router.push({
						query: { ...this.$route.query,
							id: e.id,
							code: e.code,
						}
					});
				} else if(e.type == 2) { //网关
					this.$router.push({
						query: { ...this.$route.query,
							id: e.id,
							code: e.code,
						}
					});
				} else {
					this.$router.push({
						query: { ...this.$route.query,
							id: e.id,
							code: e.code,
						}
					});
				}
			},
			filterNode(value, data) {
				if(!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
			},
			//新增用户
			addClick() {
				this.title = "新建用户"
				this.dialogFormVisible = true

			},
			firstClick() {

			},
			//配电室
			secondClick() {
				this.$router.push({
					path: '/customer/equipment',
					name: 'Equipment'
				})
			},
			thirdClick() {},
			//网关
			fourthClick() {
				this.$router.push({
					path: '/customer/gateway',
					name: 'Gateway'
				})
			},
			//返回TODO
			backClick() {
				this.$router.push({
					path: '/customer/customerDetail',
					name: 'CustomerDetail',
					query: {
						id: this.b_id,
						sI: this.secondPageIndex,
						fI: this.firstPageIndex
					}
				})
			},
			//获取列表
			getList() {
				this.loading = true;
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
					c_id: this.c_id,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/project/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.tableData = res.data
						this.tableData.forEach(item => {
							item.icon = 'iconfont icon-duidiedefangkuai-copy duidieClass'
						})
						for(var i = 0; i < this.tableData.length; i++) {
							//this.func3(0, this.tableData[i].id)
							this.func2(this.tableData[i].id, i)
						}
					} else {
						this.tableData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取子列表
			func2(project_id, i) {
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
					project_id: project_id,
				}
				axios.get(this.http + '/zkep2/subproject/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res.data)
					if(res.data.length > 0) {
						var arrS = []
						var arrP = []
						res.data.forEach(item => {
							this.tableData.push(item)
						})
						this.tableData.forEach(item => {
							if(item.parent_id != undefined) {
								arrS.push(item)
							}
						})
						this.tableData.forEach(item => {
							if(item.parent_id == undefined) {
								arrP.push(item)
							}
						})
						var childList = this.listToTree2(arrS)
						arrP.forEach(item => {
							var arr = []
							childList.forEach(item_c => {
								if(item.id == item_c.project_id) {
									arr.push(item_c)
									item.children = arr
								}
							})
						})
						this.projectList = arrP
						this.$nextTick(() => {
							if(this.$route.query.code) {
								this.currentNodeKey = this.$route.query.code
							}
							this.$refs.tree.setCurrentKey(this.currentNodeKey);
							this.$nextTick(() => {
								if(document.querySelector(".is-current") && document.querySelector(".is-current").firstChild) {
									document.querySelector(".is-current").firstChild.click();
									let nodeOffsetTop = document.querySelector('.is-current').offsetTop;
									let parentNodeClientHeight = document.querySelector('#filterTree').clientHeight;
									let parentNodeScrollHeight = document.querySelector('.el-tree-node').scrollHeight;
									//								if(nodeOffsetTop > parentNodeClientHeight) {
									document.querySelector('.leftBox').scrollTop = nodeOffsetTop - parentNodeClientHeight / 100;
									//								}
								}
							});
						})
					} else {
						if(i == 0) {
							this.projectList = this.tableData
						}
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//处理子列表为树状结构
			listToTree2(list) {
				if(!this.currentNodeKey) {
					setTimeout(() => {
						document.getElementsByClassName('el-tree-node__content')[0].click();
					}, 300);
				}
				//遍历整个列表
				return list.filter(cur => {
					// 获取当前节点的子节点
					let children = list.filter(item => item.parent_id == cur.id);
					if(children.length > 0) {
						cur.children = children;
					}
					cur.icon = 'iconfont icon-duidiedefangkuai-copy duidieClass'
					//只返回顶级节点
					return cur.parent_id == 0;
				});
			},
			/*已弃用*/
			//递归获取子列表
			func3(parent_id, project_id) {
				this.getSubs(parent_id, project_id).then(res => {
					if(res.length == 0) {
						if(this.projectList.length == 0) {
							this.projectList = this.tableData
						}
						return
					}
					//var j = 0;
					//j++;
					//console.log(res, parent_id, project_id)
					for(var i = 0; i < res.length; i++) {
						this.tableData.push(res[i])
						var res2 = this.func3(res[i].id, res[i].project_id)
						if(!res2) {
							continue;
						}
					}
					//if(j == res.length) {
					var arrS = []
					var arrP = []
					this.tableData.forEach(item => {
						if(item.parent_id != undefined) {
							arrS.push(item)
						}
					})
					this.tableData.forEach(item => {
						if(item.parent_id == undefined) {
							arrP.push(item)
						}
					})
					var childList = this.listToTree2(arrS)
					arrP.forEach(item => {
						var arr = []
						childList.forEach(item_c => {
							if(item.id == item_c.project_id) {
								arr.push(item_c)
								item.children = arr
							}
						})
					})
					this.projectList = arrP
					this.$nextTick(() => {
						if(this.$route.query.code) {
							this.currentNodeKey = this.$route.query.code
						}
						this.$refs.tree.setCurrentKey(this.currentNodeKey);
						this.$nextTick(() => {
							if(document.querySelector(".is-current") && document.querySelector(".is-current").firstChild) {
								document.querySelector(".is-current").firstChild.click();
								let nodeOffsetTop = document.querySelector('.is-current').offsetTop;
								let parentNodeClientHeight = document.querySelector('#filterTree').clientHeight;
								let parentNodeScrollHeight = document.querySelector('.el-tree-node').scrollHeight;
								//								if(nodeOffsetTop > parentNodeClientHeight) {
								document.querySelector('.leftBox').scrollTop = nodeOffsetTop - parentNodeClientHeight / 2;
								//								}
							}
						});
					})
					//console.log(this.projectList, '--------------')
					//}
					return res
				})
			},
			/*已弃用*/
			//获取子列表
			getSubs(parent_id, project_id) {
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				return new Promise(resolve => {
					$.ajax({
						url: this.http + '/zkep2/subproject/getListByLimit',
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						},
						data: {
							pageSize: -1,
							pageIndex: this.pageIndex,
							project_id: project_id,
							parent_id: parent_id
						},
						success: function(res) {
							resolve(res);
						}
					})
				});
			},

		}
	}
</script>

<style>
	.customerC {
		height: 100%;
		display: flex;
	}
	
	.customerC .leftBox {
		flex: 1;
		position: relative;
		display: inline-block;
		background-color: #fff;
		height: 100%;
		padding: 10px 16px 10px 10px;
		vertical-align: top;
		/*todo*/
		/*height:650px;*/
		overflow: auto;
		min-width: 180px;
	}
	
	.customerC .addButtonClass {
		padding: 10px 28px;
		font-size: 13px;
	}
	
	.customerC .addButtonClass2 {
		padding: 5px 1px;
		font-size: 13px;
		border: 1px solid #1989FA;
		background-color: #fff;
		border-radius: 3px;
		margin-right: 2px;
	}
	
	.customerC .nameClass {
		position: absolute;
		top: 20px;
		right: 18px;
		color: #439DFD;
		font-weight: 600;
		font-size: 14px;
	}
	
	.customerC .tabBox {
		min-width: 180px;
		margin-bottom: 20px;
		margin-top: 10px;
	}
	
	.customerC .tabFirst,
	.customerC .tabSecond,
	.customerC .tabThird,
	.customerC .tabFourth {
		height: 36px;
		line-height: 36px;
		width: 100%;
		margin-bottom: 6px;
		margin-top: 6px;
		box-shadow: 0px 2px 8px #999;
		color: #439DFD;
		font-size: 13px;
	}
	
	.customerC .tabFirst .duidieClass,
	.customerC .tabSecond .duidieClass,
	.customerC .tabThird .duidieClass,
	.customerC .tabFourth .duidieClass {
		color: #439DFD;
		margin-left: 6%;
		margin-right: 2%;
		vertical-align: middle;
		font-size: 13px;
	}
	
	.customerC .tabSecond .duidieClass {
		margin-left: 16%;
	}
	
	.customerC .tabThird .duidieClass {
		margin-left: 24%;
	}
	
	.customerC .tabFourth .duidieClass {
		margin-left: 34%;
	}
	
	.customerC .contenBox {
		flex: 4;
		display: inline-block;
		/*background-color: pink;*/
		height: 100%;
		width: 77.8%;
	}
	
	.customerC .el-table th {
		color: #000;
	}
	
	.customerC .el-table {
		font-size: 12px;
	}
	
	.customerC .el-table th,
	.customerC .el-table td,
	.customerC .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: center;
	}
	
	.customerC .el-table th {
		padding: 10px 0!important;
		font-weight: 400;
		color: #999;
	}
	
	.customerC .headerBox {
		position: relative;
		height: 30px;
		line-height: 30px;
		padding: 6px 30px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
		font-size: 13px;
		margin-bottom: 10px;
	}
	
	.customerC .tableBox {
		padding: 0 20px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
	}
	
	.customerC .el-dialog__title {
		color: #999;
	}
	
	.customerC .el-dialog__footer {
		text-align: center;
	}
	
	.customerC .pagination {
		text-align: center;
	}
	
	.customerC .pagination .el-input__inner {
		height: 30px;
		line-height: 30px;
	}
	/*滚动条的样式*/
	
	.leftBox::-webkit-scrollbar {
		width: 10px;
	}
	
	.leftBox::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}
	
	.leftBox::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}
	
	.duidieClass {
		margin: 0 8px 0 4px;
		font-size: 16px;
	}
	/*el-tree*/
	
	.customerC .el-tree {
		font-size: 13px;
	}
	/* 改变被点击节点背景颜色，字体颜色 */
	
	.customerC .el-tree-node:focus>.el-tree-node__content {
		background-color: #fff !important;
	}
	/*节点失焦时的背景颜色*/
	
	.customerC .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
		background-color: #fff !important;
	}
	
	.customerC .el-tree-node__content {
		height: 36px;
	}
	
	.customerC .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
		background-color: #457ED8!important;
		color: #fff!important;
		font-size: 14px;
	}
	/*折叠图标*/
	
	.customerC .el-tree-node__expand-icon.expanded {
		/*去掉旋转*/
		-webkit-transform: rotate( 0);
		transform: rotate( 0);
	}
	
	.customerC .el-icon-caret-right:before {
		/*折叠*/
		content: "\E782";
		font-size: 16px;
	}
	
	.customerC .el-tree-node__expand-icon.expanded.el-icon-caret-right::before {
		/*展开*/
		content: "\E789";
		font-size: 16px;
	}
	
	.customerC .el-tree-node__expand-icon {
		/*去掉颜色*/
		color: none;
	}
	
	.customerC .el-tree-node__content {
		color: #439DFD;
		font-size: 13px;
		box-shadow: 0px 2px 5px #777;
		background-color: #fff;
		margin: 3px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Customer/CustomerC.vue